/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Builders_DescriptionInputs */

const en_directory_builders_description = /** @type {(inputs: Directory_Builders_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview how public builder identities, product ownership, and activity can be presented. Names and activity below are sample data.`)
};

const zh_directory_builders_description = /** @type {(inputs: Directory_Builders_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览公开创作者身份、产品归属和活跃记录的呈现方式。下方姓名与活动均为示例数据。`)
};

/**
* | output |
* | --- |
* | "Preview how public builder identities, product ownership, and activity can be presented. Names and activity below are sample data." |
*
* @param {Directory_Builders_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_builders_description = /** @type {((inputs?: Directory_Builders_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Builders_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_builders_description(inputs)
	return zh_directory_builders_description(inputs)
});
export { directory_builders_description as "directory.builders.description" }